import { chunk } from 'lodash'

const delay = (time = 0) => new Promise((resolve) => setTimeout(resolve, Math.max(time, 0)))

/**
 * @deprecated
 * @template T
 */
export class PromiseIterator {
	chunkSize = 1000

	constructor(promise, mapFunction) {
		this.promise = promise
		this.mapFunction = mapFunction
	}

	/**
	 *
	 * @param {(item: T) => void} onItem
	 * @param {() => void} onDone
	 */
	async foreach(onItem, onDone) {
		try {
			// NOTE: split the data into chunks to avoid long freezes, when process massive array at once
			const data = await this.promise
			const dataChunks = chunk(data, this.chunkSize)
			const result = []

			await Promise.all(
				dataChunks.map(async (dataChunk) => {
					await delay()
					const items = dataChunk.map((item) => onItem(this.mapFunction?.(item) ?? item))
					result.splice(result.length, 0, ...items)
				}),
			)
		} finally {
			onDone?.()
		}
	}

	/**
	 * @returns {Promise<T[]>}
	 */
	async toPromise() {
		return new Promise((resolve) => {
			const result = []
			this.foreach(
				(item) => { result.push(item) },
				() => { resolve(result) }
			)
		})
	}
}
